import { request } from './request';

export const acceptInvitation = (body) =>
  request(`invitation`, {
    method: 'POST',
    body,
  });
